import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/agents/id/general/page';

export const Route = createFileRoute('/_app/_chat/agents/$id/general/')({
  component: Page,
});
